module.exports = __webpack_public_path__ + "img/蜂蜜5.b55c857c.png";